import React from 'react'
import { KeyValuePairs } from '@aws-northstar/ui'
import {
	ColumnLayout,
	Container,
	ExpandableSection,
	Header
} from '@cloudscape-design/components'

type AccessDetailsProps = {
	env: string
	platformName: string
}

const AccessDetails: React.FC<AccessDetailsProps> = ({
	env,
	platformName
}) => {
  const baseUrl = 'https://gitlab.com/globetelecom/platforms/'
  const brokkrBaseUrl = process.env.REACT_APP_CODE_BROKKR_APP_URL;

  const brokkrBuilderSearchParameter = `?gl_subgroup=globetelecom/platforms/${platformName.toLowerCase()}/applications`;

	const generalDetailsKeyValuePairsItems = [
		[
			{
				label: '',
				value: (
					<a
						href={`${baseUrl}${platformName}/application`}
						target="_blank"
						rel="noopener noreferrer"
						style={{ textDecoration: 'none' }}
					>
						{`Gitlab Application Subgroup`}
					</a>
				)
			}
    ],
    [
			{
				label: '',
				value: (
					<a
						href={`${brokkrBaseUrl}/builder${brokkrBuilderSearchParameter}`}
						target="_blank"
						rel="noopener noreferrer"
						style={{ textDecoration: 'none' }}
					>
						{`Code Brokkr`}
					</a>
				)
			}
		]
	]

	return (
		<Container header={<Header variant="h3">Access Details</Header>}>
			<p style={{ color: 'grey', fontSize: 'small', marginTop: '-10px' }}>
				For accesses to the links below, you may reach out to Platform
				Engineering group (isg-ceso-platengr@globe.com.ph)
			</p>
			<ColumnLayout columns={2} variant="text-grid">
				<ExpandableSection headerText="Resource Links">
					<ColumnLayout columns={2} variant="text-grid">
						<KeyValuePairs
							key={'generalDetails'}
							items={generalDetailsKeyValuePairsItems}
						/>
					</ColumnLayout>
				</ExpandableSection>
			</ColumnLayout>
		</Container>
	)
}

export default AccessDetails
